export default __webpack_public_path__ + "static/media/stain-active.dac92cfc.png";